import { render, staticRenderFns } from "./biLabel.vue?vue&type=template&id=4321662d&scoped=true&"
import script from "./biLabel.vue?vue&type=script&lang=js&"
export * from "./biLabel.vue?vue&type=script&lang=js&"
import style0 from "./biLabel.vue?vue&type=style&index=0&id=4321662d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4321662d",
  null
  
)

export default component.exports